import { Link, useLocation } from "wouter";
import { STONKFUN_TOKEN } from "../lib/data";
import { useTheme } from "../lib/theme";

const links = [
  { href: "/", label: "Home" },
  { href: "/basket", label: "Basket" },
  { href: "/community", label: "Community" },
  { href: "/portfolio", label: "Portfolio" },
  { href: "/cycles", label: "Cycles" },
  { href: "/lottery", label: "Lottery" },
  { href: "/yield", label: "Yield" },
  { href: "/swap", label: "Swap" },
  { href: "/docs", label: "Docs" },
  { href: "/token", label: "Token" },
];

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.05 5.05l1.56 1.56M17.39 17.39l1.56 1.56M5.05 18.95l1.56-1.56M17.39 6.61l1.56-1.56"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        d="M18.5 14.2A7.2 7.2 0 0 1 9.8 5.5 7.5 7.5 0 1 0 18.5 14.2Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Header() {
  const [loc] = useLocation();
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <header className="site-header">
      <div className="topnav">
        <Link href="/" className="brand" aria-label="Stonksindex home">
          <img className="brand-mark" src="/brand/stonkindex-token-1x1.png" alt="" />
          <span className="brand-text">
            Stonks
            <i className="brand-diamond" aria-hidden />
            index
          </span>
        </Link>
        <nav className="nav-links" aria-label="Primary navigation">
          {links.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              className={loc === l.href ? "active" : undefined}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="nav-actions">
          <button
            type="button"
            className="theme-toggle"
            onClick={toggle}
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            title={isDark ? "Light mode" : "Dark mode"}
          >
            {isDark ? <SunIcon /> : <MoonIcon />}
          </button>
          <a className="btn-connect" href={STONKFUN_TOKEN} target="_blank" rel="noreferrer">
            Trade
          </a>
        </div>
      </div>
    </header>
  );
}
